var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseAssistAntiFraudSurveyCaseService = /** @class */ (function () {
    function CaseAssistAntiFraudSurveyCaseService() {
    }
    /**
     * 协催管理-反欺诈调查案件
     */
    CaseAssistAntiFraudSurveyCaseService.prototype.queryAntiFraudCaseList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudSurveyCase.queryAntiFraudCaseList,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                areaId: data.areaId,
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                customerCategory: data.customerCategory,
                overduePeriod: data.overduePeriod,
                addressDetail: data.addressDetail,
                overdueDaysMax: data.overdueDays ? data.overdueDays.max : '',
                overdueDaysMin: data.overdueDays ? data.overdueDays.min : '',
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                createTimeStart: FilterService.dateRanageFormat(data.createTime).start,
                createTimeEnd: FilterService.dateRanageFormat(data.createTime).end,
                productName: data.productName,
                surveyResults: data.surveyResults,
                labelName: data.labelName
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-反欺诈调查案件-设置调查结果
     */
    CaseAssistAntiFraudSurveyCaseService.prototype.setAntiFraudCaseByCaseId = function (data) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudSurveyCase.setAntiFraudCaseByCaseId,
            data: data,
        });
    };
    /**
     * 查看反欺诈设置纪录
     */
    CaseAssistAntiFraudSurveyCaseService.prototype.getCheatDetails = function (caseAssistId) {
        return this.netService.send({
            server: domainService.caseAssistAntiFraudSurveyCase.getCheatDetails,
            data: {
                caseAssistId: caseAssistId
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseAssistAntiFraudSurveyCaseService.prototype, "netService", void 0);
    return CaseAssistAntiFraudSurveyCaseService;
}());
export { CaseAssistAntiFraudSurveyCaseService };
